module.exports = __webpack_public_path__ + "media/unipod/icon-plumbing-2-black-849dda43.svg";